import { render, staticRenderFns } from "./SyncVariantsByDate.vue?vue&type=template&id=70bd569c"
import script from "./SyncVariantsByDate.vue?vue&type=script&lang=js"
export * from "./SyncVariantsByDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports